<template>
    <el-card>
        <template #header>
            <content-header/>
        </template>
        <el-tabs
            @tab-click="handleClick"
            v-model="activeName"
        >
            <el-tab-pane
                label="押金分析"
                name="first"
            >
                <div class="block">
                    <div class="filters">
                        <el-date-picker
                            :picker-options="pickerOptions"
                            align="right"
                            end-placeholder="结束日期"
                            range-separator="至"
                            start-placeholder="开始日期"
                            type="daterange"
                            unlink-panels
                            v-model="dateBetween"
                            value-format="yyyy-MM-dd"
                        />

                        <el-select
                            class="selectwidth"
                            placeholder="请选择区域"
                            size="small"
                            v-model="area_id"
                        >
                            <el-option
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                                v-for="item in put_areas"
                            />
                        </el-select>
                        <div
                            class="div_mch"
                            v-if="merchant_id_show"
                        >
                            <el-select
                                class="selectwidth"
                                placeholder="商户"
                                size="small"
                                v-model="merchant_id"
                            >
                                <el-option
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    v-for="item in merchant_data.options"
                                />
                            </el-select>
                        </div>
                        <el-button @click="SearchData">查询</el-button>
                    </div>
                </div>
                <!-- <div class="filters" display:flex>
                  <span>选择区域：</span>
                  <el-select
                    v-model="area_id"
                    @change="AreaChange"
                    size="small"
                    placeholder="请选择"
                    class="selectwidth"
                  >
                    <el-option
                      v-for="item in put_areas"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    />
                  </el-select>
                </div> -->
                <p>押金概况</p>
                <div class="gaikuang">
                    <el-card class="min-card">
                        <p>今日新增押金(元)</p>
                        <p class="bolod-p"> {{ todayNewAdd }}</p>
                    </el-card>
                    <el-card class="min-card">
                        <p>今日退还押金(元)</p>
                        <p class="bolod-p"> {{ todayNewRefund }}</p>
                    </el-card>
                    <el-card class="min-card">
                        <p>本月累计押金(元)</p>
                        <p class="bolod-p"> {{ thisMonthTotal }}</p>
                    </el-card>
                    <el-card class="min-card">
                        <p>总押金(元)</p>
                        <p class="bolod-p"> {{ depositTotal }}</p>
                    </el-card>
                </div>
                <p>押金增长</p>
                <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
                    <line-chart :chart-data="lineChartData"/>
                </el-row>
                <el-row>
                    <p>每日押金增长明细
                        <el-button
                            @click="exportExcel"
                            class="excel-import"
                        >导出excel
                        </el-button>
                    </p>
                    <el-table
                        :data="tableData"
                        :row-class-name="tableRowClassName"
                        id="table"
                        style="width: 100%"
                    >
                        <el-table-column label="日期">
                            <template slot-scope="scope">
                                {{ scope.row.date }}
                            </template>
                        </el-table-column>
                        <el-table-column label="新增押金（元）">
                            <template slot-scope="scope">
                                {{ scope.row.money_all }}
                            </template>
                        </el-table-column>
                        <el-table-column label="新增人数">
                            <template slot-scope="scope">
                                {{ scope.row.count_id }}
                            </template>
                        </el-table-column>
                        <el-table-column label="总退押金（元）">
                            <template slot-scope="scope">
                                {{ scope.row.money_refund_all }}
                            </template>
                        </el-table-column>
                        <el-table-column label="押金净增长（元）">
                            <template slot-scope="scope">
                                {{ scope.row.money_all - scope.row.money_refund_all }}
                            </template>
                        </el-table-column>
                        <!-- <el-table-column
                          label="总押金"
                        >
                          <template slot-scope="scope">
                            {{ scope.row.total_deposit }}
                          </template>
                        </el-table-column> -->
                    </el-table>
                </el-row>
            </el-tab-pane>
            <el-tab-pane
                label="押金明细"
                name="second"
            >
                <search-form
                    :fields="search"
                    ref="searchForm"
                />
                <el-table
                    :data="depositData"
                    class="table-font"
                    style="width: 100%"
                >
                    <el-table-column
                        align="center"
                        label="押金订单号"
                        min-width="10%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.no }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="手机号"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.mobile }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="押金类型"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.type }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="交易类型"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.transaction_type }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="金额"
                        min-width="3%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.money }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="缴纳时间"
                        min-width="7%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.pay_time }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="申请退款时间"
                        min-width="7%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.refund_created_at }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="退款成功时间"
                        min-width="7%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.refund_pay_time }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="所属区域"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.area }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="交易状态"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-tag
                                plain
                                type="success"
                            >{{ scope.row.transaction_status }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                        show-overflow-tooltip
                        width="120"
                    >
                        <template slot-scope="scope">
                            <el-button
                                @click="returnDepositDialog(scope.row)"
                                size="mini"
                                type="danger"
                                v-if="scope.row.is_refund == 0  && !estimateRegistrationTime(scope.row.pay_time)"
                            >
                                退还押金
                            </el-button>
                            <el-button
                                v-if="scope.row.is_refund == 0 && estimateRegistrationTime(scope.row.pay_time) "
                                size="mini"
                                type="danger"
                                @click="returnOutTimeDepositDialog(scope.row)"
                            >
                                退还超期押金
                            </el-button>
                            <el-button
                                @click="refundOrderDetail(scope.row)"
                                size="mini"
                                type="success"
                                v-if="scope.row.is_refund == 1"
                            >
                                详情
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="card-footer">
                    <pagination :page="page"/>
                </div>
            </el-tab-pane>
            <el-tab-pane
                label="退款订单明细"
                name="third"
            >
                <search-form
                    :fields="search1"
                    ref="searchForm1"
                />
                <el-table
                    :data="refundLogs"
                    class="table-font"
                    style="width: 100%"
                >
                    <el-table-column
                        align="center"
                        label="退款订单号"
                        min-width="8%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.no }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="手机号"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.mobile }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        align="center"
                        label="退款金额"
                        min-width="3%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.pay_money }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="发起时间"
                        min-width="7%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.created_at }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="到账时间"
                        min-width="7%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.pay_time }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="所属区域"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.area_name }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="是否成功"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-tag
                                type="success"
                                v-if="scope.row.pay_status == 1"
                            > 成功
                            </el-tag>
                            <el-tag
                                type="info"
                                v-else-if="scope.row.pay_status == 0"
                            > 未支付
                            </el-tag>
                            <el-tag
                                type="danger"
                                v-else-if="scope.row.pay_status == 2"
                            > 退款异常
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="失败原因"
                        min-width="5%"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            {{ scope.row.result }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作"
                        show-overflow-tooltip
                        width="120"
                    >
                        <template slot-scope="scope">
                            <el-button
                                @click="reReturnDeposit(scope.row)"
                                size="mini"
                                type="danger"
                                v-if="scope.row.pay_status != 1"
                            >
                                重新发起
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="card-footer">
                    <pagination
                        :auto-push="false"
                        :page="page1"
                        @current-change="walletcurrentpage"
                        @size-change="walletpagesize"
                    />
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog
            :visible.sync="return_deposit_dialogVisible"
            title="退还押金"
            width="30%"
        >
            <p>确定退还押金嘛</p>
            <span
                class="dialog-footer"
                slot="footer"
            >
        <el-button @click="return_deposit_dialogVisible = false">取 消</el-button>
        <el-button
            @click="returnDeposit"
            type="primary"
        >确 定</el-button>
      </span>
        </el-dialog>
        <el-dialog
            :visible.sync="return_out_time_deposit_dialogVisible"
            title="退还押金"
            width="30%"
        >
            <p>确定退还超时押金嘛</p>
            <span
                slot="footer"
                class="dialog-footer"
            >
        <el-button @click="return_out_time_deposit_dialogVisible = false">取 消</el-button>
        <el-button
            type="primary"
            @click="returnOutTimeDeposit"
        >确 定</el-button>
      </span>
        </el-dialog>
        <el-dialog
            :visible.sync="refundOrderShow"
            title="退款订单详情"
            width="20%"
        >
            <div class="info-body">
                <div class="info-wrpp">
                    <p class="info-title">退款订单详情</p>
                    <div class="info-item"><span>单号：</span> <span>{{ refundOrdersRow.no }}</span></div>
                    <div class="info-item"><span>退款状态：</span>
                        <span>{{ refundOrdersRow.pay_status == 1 ? '成功' : '失败' }}</span></div>
                    <div class="info-item"><span>退款原因：</span> <span>{{ refundOrdersRow.refuse_reason }}</span></div>
                    <div class="info-item"><span>退款金额：</span> <span>{{ refundOrdersRow.pay_money }}</span></div>
                </div>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
    import LineChart from "./components/LineChart";
    import XLSX from "xlsx";
    import {
        getDepositStatistics,
        getDepositOrders,
        getDepositdepositTotal,
        getrefundLogs
    } from "@/api/deposit";
    import {getAreas} from "@/api/area";
    import Pagination from "@c/Pagination";
    import SearchForm from "@c/SearchForm";
    import {userReturnDeposit, userReReturnDeposit, userReturnOutTimeDeposit} from "@/api/users";
    import {mixinsAutoPageSize} from "@/libs/utils";
    import {getAdminUsersMerchant} from "@/api/admin-merchant";
    import env from "../../env";

    export default {
        name: "Index",
        components: {
            LineChart,
            Pagination,
            SearchForm
        },
        data() {
            return {
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit("pick", [start, end]);
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit("pick", [start, end]);
                            }
                        }
                    ]
                },
                dateBetween: "",
                put_areas: [
                    {
                        id: "9999",
                        name: "全部"
                    }
                ],
                search: [
                    {
                        field: "mobile",
                        label: "手机号"
                    },

                    {
                        type: "el-select",
                        field: "area_id",
                        label: "骑行区域",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            }
                        ]
                    },
                    {
                        type: "el-select",
                        field: "is_refund",
                        label: "交易类型",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            },
                            {
                                value: "0",
                                label: "缴纳押金"
                            },
                            {
                                value: "1",
                                label: "退还押金"
                            }
                        ]
                    },
                    {
                        type: "el-select",
                        field: "type",
                        label: "押金类型",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            },
                            {
                                value: "0",
                                label: "微信小程序"
                            }
                        ]
                    },
                    {
                        type: "time-between",
                        field: "pay_time_between",
                        label1: "订单支付-开始",
                        label2: "订单支付-结束"
                    },
                    {
                        field: "no",
                        label: "订单号"
                    }
                ],
                search1: [
                    {
                        field: "mobile",
                        label: "手机号"
                    },
                    {
                        type: "el-select",
                        field: "area_id",
                        label: "骑行区域",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            }
                        ]
                    },
                    {
                        type: "el-select",
                        field: "pay_status",
                        label: "状态",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            },
                            {
                                id: "0",
                                name: "失败"
                            },
                            {
                                id: "1",
                                name: "成功"
                            }
                        ]
                    },
                    {
                        type: "time-between",
                        field: "created_time_between",
                        label1: "发起时间-开始",
                        label2: "发起时间-结束"
                    },
                    {
                        field: "no",
                        label: "订单号"
                    }
                ],
                area_id: "9999",
                todayNewAdd: 0,
                todayNewRefund: 0,
                thisMonthTotal: 0,
                depositTotal: 0,
                tableData: [],
                depositData: [],
                page: null,
                page1: null,
                page1_page_size: "",
                refundLogs: [],
                first_blood: true,
                activeName: "first",
                return_deposit_dialogVisible: false,
                return_out_time_deposit_dialogVisible: false,
                refundOrderShow: false,
                refundOrdersRow: {},
                return_deposit_user_id: 0,
                lineChartData: {
                    expectedData: {
                        data: [],
                        data1: [],
                        date: []
                    }
                },
                merchant_data: {},
                merchant_id_show: false,
                merchant_id: null
            };
        },
        inject: ["reload"],
        mixins: [mixinsAutoPageSize],
        watch: {
            $route: {
                async handler(newVal) {
                    await this.autoPageSize(50, newVal);
                    const [{data: depositData}, {data: refundLogs}] = await Promise.all(
                        [getDepositOrders(newVal.query), getrefundLogs(newVal.query)]
                    );
                    this.depositData = depositData.data;
                    this.page = depositData.meta;
                    this.refundLogs = refundLogs.data;
                    this.page1 = refundLogs.meta;
                },
                immediate: true
            }
        },
        async created() {
            const [{data: areas}] = await Promise.all([getAreas({all: 1})]);

            this.put_areas.push.apply(this.put_areas, areas);
            this.search[1].options.push.apply(this.search[1].options, areas);
            this.search1[1].options.push.apply(this.search1[1].options, areas);

            const [{data: depositTotal}] = await Promise.all([
                getDepositdepositTotal({area_id: "9999"})
            ]);
            this.depositTotal = depositTotal;

            const [{data}] = await Promise.all([
                getDepositStatistics({area_id: "9999"})
            ]);
            this.todayNewAdd = data.new_add;
            this.todayNewRefund = data.new_refund;
            this.thisMonthTotal = data.this_money_total;
            this.tableData = data.deposit_statistics;
            data.deposit_statistics.map(i => {
                this.lineChartData.expectedData.data.push(i.money_all); // 统计得押金
                this.lineChartData.expectedData.data1.push(
                    i.money_all - i.money_refund_all
                ); // 统计得押金
                this.lineChartData.expectedData.date.push(i.date);
            });

            // 反转顺序
            this.lineChartData.expectedData.data.reverse();
            this.lineChartData.expectedData.data1.reverse();
            this.lineChartData.expectedData.date.reverse();
            if (this.$store.state.users.user.roles[0] === "administrator" && env.isPosSwitch == true) {
                this.merchant_id_show = true;
                this.merchant_data = {
                    options: [
                        {
                            id: "",
                            name: "全部"
                        }
                    ]
                };
                const [{data: merchant}] = await Promise.all([
                    getAdminUsersMerchant({all: 1})
                ]);
                this.merchant_data.options.push.apply(
                    this.merchant_data.options,
                    merchant.data
                );
                if (env.isPosSwitch == true) {
                    this.search.push({
                        type: "el-select",
                        field: "merchant_id",
                        label: "商户",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            }
                        ]
                    });
                    this.search1.push({
                        type: "el-select",
                        field: "merchant_id",
                        label: "商户",
                        options: [
                            {
                                id: "",
                                name: "全部"
                            }
                        ]
                    });
                    this.search[6].options.push.apply(
                        this.search[6].options,
                        merchant.data
                    );
                    this.search1[5].options.push.apply(
                        this.search1[5].options,
                        merchant.data
                    );
                }
            }
        },
        methods: {
            estimateRegistrationTime(beginDate) {
                var begin = new Date(beginDate).getTime();
                var end = new Date().getTime();
                var day = (end - begin) / (24 * 60 * 60 * 1000);
                if (day > 365) {
                    return true;
                } else {
                    return false;
                }
            },
            returnOutTimeDepositDialog(row) {
                this.return_out_time_deposit_dialogVisible = true;
                this.return_deposit_user_id = row.user_id;
            },
            async returnOutTimeDeposit() {
                const [{data: res}] = await Promise.all([
                    userReturnOutTimeDeposit({user_id: this.return_deposit_user_id})
                ]);

                if (res) {
                    let msg = JSON.stringify(res);
                    this.$message({
                        type: "success",
                        message: msg
                    });
                    this.reload();
                }
            },
            returnDepositDialog(row) {
                // 退还押金
                this.return_deposit_dialogVisible = true;
                this.return_deposit_user_id = row.user_id;
            },
            refundOrderDetail(row) {
                this.refundOrderShow = true;
                this.refundOrdersRow = row.refundOrder;
                console.log(row.refundOrder);
            },
            async returnDeposit() {
                const [{data: res}] = await Promise.all([
                    userReturnDeposit({user_id: this.return_deposit_user_id})
                ]);

                if (res) {
                    let msg = JSON.stringify(res);
                    this.$message({
                        type: "success",
                        message: msg
                    });
                    this.reload();
                }
            },
            // 递归函数
            // budata(expectedData) {
            //   if (expectedData.length < 15) {
            //     expectedData.push(0)
            //     this.budata(expectedData)
            //   }
            // },
            async SearchData() {
                this.lineChartData.expectedData.data = [];
                this.lineChartData.expectedData.data1 = [];
                this.lineChartData.expectedData.date = [];
                // console.log(this.area_id)
                var params = {area_id: this.area_id, merchant_id: this.merchant_id};
                if (this.dateBetween !== null) {
                    params = {
                        area_id: this.area_id,
                        dateBetween: this.dateBetween,
                        merchant_id: this.merchant_id
                    };
                }

                const [{data: depositTotal}] = await Promise.all([
                    getDepositdepositTotal(params)
                ]);
                this.depositTotal = depositTotal;

                const [{data}] = await Promise.all([getDepositStatistics(params)]);
                // console.log(data)
                this.todayNewAdd = data.new_add;
                this.todayNewRefund = data.new_refund;
                this.thisMonthTotal = data.this_money_total;
                this.tableData = data.deposit_statistics;
                data.deposit_statistics.map(i => {
                    this.lineChartData.expectedData.data.push(i.money_all);
                    this.lineChartData.expectedData.data1.push(
                        i.money_all - i.money_refund_all
                    );
                    this.lineChartData.expectedData.date.push(i.date);
                });
                // this.lineChartData.expectedData.reverse()
                // this.budata(this.lineChartData.expectedData)
                this.lineChartData.expectedData.data.reverse();
                this.lineChartData.expectedData.data1.reverse();
                this.lineChartData.expectedData.date.reverse();
            },
            handleClick(tab, event) {
                // console.log(tab.name)
                // console.log(this.$route)
                // this.$route.path += '/#'
                this.$router.push({
                    path: this.$route.path
                });
                if (tab.name == "second") {
                    this.$refs.searchForm.onReset();
                } else if (tab.name == "third") {
                    this.$refs.searchForm1.onReset();
                } else {
                    this.$refs.searchForm.onReset();

                    this.$refs.searchForm1.onReset();
                }
                // this.$refs.searchForm1.onReset()
            },
            tableRowClassName({row, rowIndex}) {
                // console.log(111222)
                if (rowIndex === 1) {
                    return "warning-row";
                } else if (rowIndex === 3) {
                    return "success-row";
                }
                return "";
            },
            exportExcel() {
                let workbook = XLSX.utils.table_to_book(document.getElementById("table"));
                try {
                    XLSX.writeFile(workbook, "deposit.xlsx");
                } catch (e) {
                    console.log(e, workbook);
                    this.$message.error("导出失败请联系管理员");
                }
            },
            async walletcurrentpage(i) {
                this.page1.current_page = i;
                console.log(i, this.$refs.searchForm1.from);
                if (this.page1_page_size == "") {
                    let clientHeight = document.body.clientHeight;
                    this.page1.page_size = Math.floor((clientHeight - 360) / 48);
                } else {
                    this.page1.page_size = this.page1_page_size;
                }
                let where = this.$refs.searchForm1.form
                const {
                    data: {data, meta}
                } = await getrefundLogs({
                    page: this.page1.current_page,
                    per_page: this.page1.page_size,
                    area_id: where.area_id,
                    created_time_between: where.created_time_between,
                    mobile: where.mobile,
                    no: where.no,
                    pay_status: where.pay_status,
                });
                this.refundLogs = data;
                this.page1 = meta;
            },
            async walletpagesize(i) {
                this.page1.page_size = i;
                this.page1_page_size = i;
                let where = this.$refs.searchForm1.form
                const {
                    data: {data, meta}
                } = await getrefundLogs({
                    page: this.page1.current_page,
                    per_page: this.page1.page_size,
                    area_id: where.area_id,
                    created_time_between: where.created_time_between,
                    mobile: where.mobile,
                    no: where.no,
                    pay_status: where.pay_status,
                });
                this.refundLogs = data;
                this.page1 = meta;
            },
            reReturnDeposit(row) {
                userReReturnDeposit({refund_no: row.no}).then(res => {
                    res.then(data => {
                        this.$message({
                            message: JSON.stringify(data.data),
                            type: "success"
                        });
                    });
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
    .gaikuang {
        display: flex;

        .min-card {
            width: 350px;
            padding: 10px 20px;
            margin: 5px 25px;
            background: rgba(3, 134, 128, 0.1);
            // align-items: center;
            text-align: center;
            font-size: 20px;

            p {
                margin: 10px;
            }

            .bolod-p {
                font-size: 2rem;
            }
        }
    }

    .el-table .warning-row {
        background: #fdf5e6 !important;
    }

    .el-table .success-row {
        background: #f0f9eb !important;
    }

    .table-font {
        font-size: 12px;
    }

    .filters {
        margin-right: 15px;
        text-align: right;
        margin: 10px;

        .selectwidth {
            padding-left: 30px;
            width: 200px;
            margin-right: 15px;
        }
    }

    .block {
        margin: 10px 0px;
        display: flex;
        justify-content: space-between;
    }

    .excel-import {
        float: right;
        margin-bottom: 10px;
    }

    .info-body {
        color: #606266;
        width: 100%;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;

        .info-wrpp {
            width: 100%;
            margin: 10px 10px 20px 0;
            padding-bottom: 10px;
            background-color: #eee;

            .info-item {
                margin-bottom: 10px;

                :first-child {
                    display: inline-block;
                    width: 100px;
                    text-align: right;
                }

                span :last-child {
                    padding-left: 10px;
                }

                .amount {
                    font-size: 18px;
                    color: coral;
                    margin-right: 5px;
                }

                .amountt {
                    color: coral;
                }

                .cost {
                    padding-left: 102px;
                    padding-top: 8px;

                    .resetwid {
                        width: auto;
                    }

                    p {
                        margin: 0;

                        .inline-span {
                            display: inline;
                        }

                        span {
                            display: inline;
                        }
                    }
                }
            }
        }
    }

    .info-title {
        font-weight: 700;
        font-size: 16px;
        margin: 20px 0 20px;
        padding-left: 10px;
        color: #606266;

        .info-huanche {
            color: red;
            font-size: 13px;
        }
    }

    .div_mch {
        float: left;
        margin-top: 2px;
    }
</style>
